import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon, Card, Modal } from 'ui';
import LinkButton from 'components/shared/LinkButton';
import Tooltip from 'components/shared/Tooltip';
import SessionDetails from 'components/InPersonTraining/shared/SessionDetails';
import ZoomContext from 'components/InPersonTraining/shared/ZoomContext';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import FeatureFlag from 'components/shared/FeatureFlag';
import EditForm from './EditForm';
import AddSessionForm from './AddSessionForm';
import SessionRegisterLink from './SessionRegisterLink';

class Session extends Component {
  state = {
    editing: false,
    addingSession: false,
  };

  toggleEditing = () => {
    this.setState(state => ({ editing: !state.editing }));
  };

  toggleAddingSession = () => {
    this.setState(state => ({ addingSession: !state.addingSession }));
  };

  render() {
    const {
      session,
      eventId,
      isArchived,
      meta,
      sessionCount,
      event,
      rsvpType,
    } = this.props;
    const { editing, addingSession } = this.state;
    const { currentUser, currentCompany, zoomClientId } = meta;
    return (
      <ZoomContext.Provider value={{ zoomClientId }}>
        <Modal
          shown={addingSession}
          onDismiss={this.toggleAddingSession}
          canClickAway={false}
          className="w-725p Modal-shell"
          enableFloatingDismiss
        >
          <Modal.Content>
            <AddSessionForm
              addingSession={addingSession}
              eventId={eventId}
              event={event}
              rsvpType={rsvpType}
              session={session}
              sessionCount={sessionCount}
              currentUser={currentUser}
              currentCompany={currentCompany}
              onDismiss={this.toggleAddingSession}
            />
          </Modal.Content>
        </Modal>
        <Card className="EventSession">
          {editing && (
            <EditForm
              eventId={eventId}
              session={session}
              currentUser={currentUser}
              currentCompany={currentCompany}
              onDismiss={this.toggleEditing}
            />
          )}
          {!editing && (
            <>
              <Card.Content className="fz-base" padding="medium">
                <div className="d-f jc-sb ai-fs">
                  <div className="d-f fd-c">
                    <Text variant={TEXT_VARIANTS.SUBHEADER_BOLD}>
                      {t('in_person_training.event_details')}
                    </Text>
                  </div>
                  <div>
                    <FeatureFlag
                      features={['readiness-enable-multisession-events']}
                    >
                      <LinkButton
                        disabled={isArchived || sessionCount > 4}
                        type="primary"
                        className="pr-16"
                        onClick={this.toggleAddingSession}
                      >
                        <Icon name="add" className="mr-4" />
                        {t('in_person_training.event_overview.session.add')}
                      </LinkButton>
                    </FeatureFlag>
                    <Tooltip
                      text={
                        isArchived &&
                        t(
                          'in_person_training.event_overview.archived_cannot_be_edited',
                        )
                      }
                    >
                      <LinkButton
                        disabled={isArchived}
                        type="primary"
                        onClick={this.toggleEditing}
                      >
                        <Icon name="edit" className="mr-4" />
                        {t('common.edit')}
                      </LinkButton>
                    </Tooltip>
                  </div>
                </div>
                <SessionDetails
                  className="mt-20"
                  session={session}
                  eventId={eventId}
                  adminView
                />
              </Card.Content>
              <Card.Content
                className="bg-gray-lightest bt-gray-lighter"
                padding="large"
              >
                <SessionRegisterLink
                  link={`${session.urls.register}?shared=true`}
                />
              </Card.Content>
            </>
          )}
        </Card>
      </ZoomContext.Provider>
    );
  }
}

const mapStateToProps = ({ event, meta }) => ({
  isArchived: event.is_archived,
  rsvpType: event.rsvp_type,
});

export default connect(mapStateToProps)(Session);
